// extracted by mini-css-extract-plugin
export default {"location":"index_location__1JMXK typography_bodyFont__3RHTp","pinIcon":"index_pinIcon__1F-IM"};